import { LabelValueOptionModel } from '@/domain/models/onboarding/label-value-option-model'
import { SkillModel } from '@/domain/models/onboarding/user-onboarding-model'
import { Account } from '@/domain/usecases'
import { OnboardingOptions } from '@/domain/usecases/onboarding/onboarding-options'
import { UserOnboarding } from '@/domain/usecases/onboarding/user-onboarding'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'
import RegisteredPlanBaseLoader from '../registered-plan-base-loader'

export type UserInterestAreasSkillsLoaderType = {
  interestAreas: {
    selected: number[]
    options: LabelValueOptionModel<number>[]
  }
  skills: {
    selected: SkillModel[]
    options: LabelValueOptionModel<number>[]
  }
}

export default class UserInterestAreasSkillsLoader extends RegisteredPlanBaseLoader {
  constructor(account: Account.Model, ldClient: LDClient, queryClient: QueryClient) {
    super(account, queryClient, ldClient, FeatureFlag.Key.COMPANIES_ON_USER_INTEREST_AREAS_SKILLS)
  }

  private async getRemotes() {
    return Promise.all([
      super.importRemoteModule('makeRemoteUserOnboarding').then(async makeRemoteUserOnboarding => {
        return makeRemoteUserOnboarding(this.queryClient) as UserOnboarding
      }),
      super
        .importRemoteModule('makeRemoteOnboardingOptions')
        .then(async makeRemoteOnboardingOptions => {
          return makeRemoteOnboardingOptions(this.queryClient) as OnboardingOptions
        })
    ]).then(([remoteData, remoteOptions]) => {
      return {
        remoteData,
        remoteOptions
      }
    })
  }

  async loader() {
    return this.defer({
      data: this.getRemotes().then(async ({ remoteData, remoteOptions }) => {
        return Promise.all([
          remoteData.get(),
          remoteOptions.getStep3(),
          remoteOptions.getStep4()
        ]).then(([data, optionsStep3, optionsStep4]) => {
          return {
            interestAreas: {
              selected: data.interest.areasId,
              options: optionsStep3.interestAreas
            },
            skills: {
              selected: data.interest.skills,
              options: optionsStep4.skillOptions
            }
          }
        })
      })
    })
  }
}
